export default __webpack_public_path__ + "static/media/ourclient6.784ec9a0.png";